











































































import { AuthenticationApi } from "@/api";
import stateMixin from "@/mixins/state";
import isPassword from "@/util/validators/password";

export default {
  data() {
    return {
      isActivation: false,
      valid: true,
      fields: {
        password: "",
        passwordRepeat: ""
      },
      token: "",
      rules: {
        password: [
          v => !!v || "Wachtwoord is verplicht",
          v =>
            isPassword(v) ||
            "Wachtwoord voldoet niet aan de vereisten: 8 karakters, 1 hoofdletter, 1 kleine letter en 1 cijfer"
        ],
        passwordRepeat: [v => !!v || "Herhaal wachtwoord is verplicht"]
      }
    };
  },
  name: "SettingsSecurity",
  mixins: [stateMixin],
  mounted() {
    if (
      this.$route.query.token !== undefined &&
      this.$route.query.token !== ""
    ) {
      if (this.$route.name === "activateAccount") {
        this.isActivation = true;
      }
      this.check(this.$route.query.token);
    } else {
      this.setState(this.states.ERROR);
    }
  },
  methods: {
    check: async function(token) {
      this.setState(this.states.LOADING);
      const api = new AuthenticationApi();
      try {
        if (this.isActivation) {
          const { data } = await api.authenticationIsActivationKeyValid({
            activationToken: token
          });
        } else {
          const { data } = await api.authenticationIsPasswordResetTokenValid({
            passwordResetToken: token
          });
        }
        this.token = token;
        this.setState(this.states.LOADED);
      } catch {
        this.setState(this.states.ERROR);
      }
    },
    submit: async function() {
      if (this.valid) {
        this.setState(this.states.LOADING);
        const api = new AuthenticationApi();
        try {
          if (this.isActivation) {
            const result = await api.authenticationActivateAccount({
              activationToken: this.token,
              ...this.fields
            });
          } else {
            const result = await api.authenticationResetPassword({
              passwordResetToken: this.token,
              ...this.fields
            });
          }
          this.setState(this.states.COMPLETED);
        } catch (e) {
          this.setState(this.states.ERROR);
        }
      }
    }
  }
};
